export const DataTestId = {
  // apps/sessions
  cellStatus: 'cell-status',
  cellBookingType: 'cell-booking-type',
  userName: '__userName',
  // apps/clients
} as const;
